import { render, staticRenderFns } from "./PrecioTratamientoSesion.vue?vue&type=template&id=5cf02c2d"
import script from "./PrecioTratamientoSesion.vue?vue&type=script&lang=js"
export * from "./PrecioTratamientoSesion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports